import { CategoryEnum } from "./types";

export const CATEGORY_ORDER: CategoryEnum[] = [
  CategoryEnum.CRYPTO,
  CategoryEnum.STOCKS,
  CategoryEnum.COMMODITIES,
  CategoryEnum.FX,
  CategoryEnum.INDICES,
  CategoryEnum.PRE_IPO,
];

export const normalizeCategory = (
  category?: string,
  isPrelaunch?: boolean
): CategoryEnum => {
  const normalized = category?.trim().toLowerCase();
  if (isPrelaunch || normalized === "pre-ipo" || normalized === "pre ipo") {
    return CategoryEnum.PRE_IPO;
  }
  if (normalized === "stocks") return CategoryEnum.STOCKS;
  if (normalized === "commodities") return CategoryEnum.COMMODITIES;
  if (normalized === "fx") return CategoryEnum.FX;
  if (normalized === "indices") return CategoryEnum.INDICES;
  return CategoryEnum.CRYPTO;
};
